// import firebase from "firebase/app";
import {initializeApp} from "firebase/app";
import {getFirestore} from "firebase/firestore"
import {getStorage} from "firebase/storage"
// import "firebase/firestore";
// import "firebase/storage";

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  // databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

// firebase.initializeApp(config);
const firebase = initializeApp(config);
export default firebase;

// export const firestore = firebase.firestore();
export const firestore = getFirestore(firebase);
// export const storage = firebase.storage();
export const storage = getStorage(firebase);
